<template>
    <div class="flex antialiased text-gray-800" style="height:90vh">
        <div class="flex flex-row h-full w-full">
            <Sidebar
                :conversations="conversations"
                :selected-conversation-id="selectedConversationId"
                @conversation-selected="fetchMessages"
            />
            <div class="flex flex-col flex-auto h-full p-6">
                <div class="flex flex-col flex-auto flex-shrink-0 rounded-2xl bg-gray-100 h-full p-4">
                    <div ref="msgContainer" class="flex flex-col h-full overflow-x-auto mb-4">
                        <Messages v-if="conversations.length > 0" :messages="messages" />
                        <div v-else class="inline-block justify-center mx-auto align-middle my-auto">
                            <svg-icon icon="chat" class="w-48"></svg-icon>
                            <p class="-ml-12">There is no message for the conversation</p>
                        </div>
                    </div>
                    <form v-if="form && selectedConversationId" @submit.prevent="sendMessage">
                        <div class="flex flex-row items-center h-16 rounded-xl bg-white w-full">
                            <div class="flex-grow ml-4">
                                <div class="relative w-full">
                                    <my-textarea
                                        v-model="form.message"
                                        :rows="1"
                                        name="message"
                                        :error="form.errors.get('message')"
                                        placeholder="Your Message"
                                        show-resize="none"
                                        @keydown.native.enter.exact.prevent
                                        @keydown.native.enter.exact="sendMessage"
                                    />
                                </div>
                            </div>
                            <div class="ml-4">
                                <my-button
                                    :loading="sending"
                                    class="btn btn-primary px-6 md:px-8 font-bold"
                                    type="submit"
                                    progress-text="Sending"
                                >
                                    Send
                                </my-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '../../forms/form';
import Sidebar from './Sidebar';
import Messages from './Messages';

export default {
    components: { Messages, Sidebar },

    props: {
        conversations: {
            type: Array,
            required: true
        },
        activeConversationId: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            messages: [],
            form: new Form({
                message: null
            }),
            sending: false,
            submitting: false,
            selectedConversationId: 0
        };
    },

    mounted() {
        if (this.conversations.length > 0) {
            this.selectedConversationId = this.activeConversationId
                ? this.activeConversationId
                : this.conversations[0].conversation_id;
            this.fetchMessages(this.selectedConversationId);
        }
    },

    methods: {
        fetchMessages(conversationId) {
            axios
                .get(`/api/conversations/${conversationId}/messages`)
                .then(response => {
                    this.selectedConversationId = conversationId;
                    this.messages = response.data.data;
                    if (this.messages[this.messages.length - 1].is_seen === 0) this.markAsReadConversationMessages();
                    this.scrollToBottom();
                    this.initListener();
                })
                .catch(() => flash.error());
        },

        sendMessage() {
            if (this.sending || !this.form.message) {
                return;
            }

            this.sending = true;

            axios
                .post(`/api/conversations/${this.selectedConversationId}/messages`, {
                    body: this.form.message
                })
                .then(response => {
                    let newMessage = response.data.data;
                    newMessage.is_sender = 1;
                    this.messages.push(newMessage);
                    this.scrollToBottom();
                })
                .catch(() => flash.error())
                .finally(() => {
                    this.sending = false;
                    this.form.message = null;
                });
        },

        scrollToBottom() {
            this.$nextTick(() => (this.$refs.msgContainer.scrollTop = this.$refs.msgContainer.scrollHeight));
        },

        initListener() {
            Echo.private(`mc-chat-conversation.${this.selectedConversationId}`).listen(
                '.Musonza\\Chat\\Eventing\\MessageWasSent',
                e => {
                    this.onMessageReceived(e.message);
                }
            );
        },

        onMessageReceived(message) {
            let newMessage = message;
            newMessage.is_sender = 0;
            this.messages.push(newMessage);
            this.scrollToBottom();
        },

        markAsReadConversationMessages() {
            axios.post(`/api/conversations/${this.selectedConversationId}/mark-read`).then(() => {
                this.messages[this.messages.length - 1].is_seen = 1;
                this.conversations.map(conversation => {
                    if (this.selectedConversationId == conversation.conversation_id)
                        return (conversation.conversation.last_message.is_seen = 1);
                    return conversation;
                });
            });
        }
    }
};
</script>
